import { Operation } from '../../../__generated__/globalTypes'

import {
  AwardGroupFragment,
  awardGroupFragmentString,
} from '../../fragments/__generated__/AwardGroupFragment'

import { awardFragmentString } from '../../fragments/__generated__/AwardFragment'

import getAwardGroupsRawString from '../GetAwardGroups.graphql'

const getAwardGroupsString = [
  getAwardGroupsRawString,
  awardGroupFragmentString,
  awardFragmentString,
].join('\n\n')

export type GetAwardGroupsData = {
  awardGroups: AwardGroupFragment[]
}

export type GetAwardGroups = Operation<GetAwardGroupsData>

export const GetAwardGroups = (): GetAwardGroups => ({
  query: getAwardGroupsString,
  variables: undefined,
})
